/* global fetch */

import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

export const getById = (st: SpanTag, id: string): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${id}`;
  return fetchAPI(stleaf(st, 'ousho3'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};

export enum ReviewStatus {
  Neutral = 'neutral',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Review = 'review',
  Failed = 'failed',
}

export enum CaptureStatus {
  Pending = 'pending',
  Partial = 'partial',
  Complete = 'complete',
}

export const review = (
  st: SpanTag,
  id: string,
  {
    reviewStatus,
    rejectionNotes,
  }: { reviewStatus: ReviewStatus; rejectionNotes?: string },
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${id}/status`;
  return fetchAPI(stleaf(st, 'aij6ah'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify({
      reviewStatus,
      rejectionNotes,
    }),
  });
};

export const importShapefile = (
  st: SpanTag,
  missionId: string,
  blob,
): Promise<APIResponse> => {
  const url = new URL(
    `${config.API_URL}/v1/objectives/shapefile?mission-id=${missionId}`,
  );
  return fetchAPI(stleaf(st, 'eif4to'), url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/octet-stream',
      Accept: 'application/json',
    },
    body: blob,
  });
};

export const recapture = (
  st: SpanTag,
  objectiveId: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${objectiveId}/recapture`;
  return fetchAPI(stleaf(st, 'rouk4o'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
  });
};

// TODO: Ops only, move
export const markObjectiveIncomplete = (
  st: SpanTag,
  opts: { objectiveId: string },
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${opts.objectiveId}/status/pending`;
  return fetchAPI(stleaf(st, 'aihoe7'), url, {
    method: 'PUT',
    credentials: 'include',
    headers,
  });
};

export const updateDetails = (
  st: SpanTag,
  objectiveId: string,
  details: null | { [key: string]: any },
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${objectiveId}/details`;
  return fetchAPI(stleaf(st, 'oer0oh'), url, {
    method: 'PUT',
    credentials: 'include',
    headers,
    body: JSON.stringify(details),
  });
};

export const updateMappingDetails = (
  st: SpanTag,
  objectiveId: string,
  mappingDetails: null | { [key: string]: any },
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${objectiveId}/mapping-details`;
  return fetchAPI(stleaf(st, 'ao4eep'), url, {
    method: 'PUT',
    credentials: 'include',
    headers,
    body: JSON.stringify(mappingDetails),
  });
};

interface MappingDetailsPDFResponse {
  url: string | null;
}

export const getMappingDetailsPDF = (
  st: SpanTag,
  objectiveId: string,
): Promise<APIResponse<MappingDetailsPDFResponse>> => {
  const url = `${config.API_URL}/v1/objectives/${objectiveId}/mapping-details`;
  return fetchAPI<MappingDetailsPDFResponse>(stleaf(st, 'ohph7l'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  }).catch((err) => {
    console.error(err);
    return { body: { url: null }, status: 400 };
  });
};

export const dereferenceMediaItem = (
  st: SpanTag,
  objectiveId: string,
  mediaId: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/objectives/${objectiveId}/media/${mediaId}`;
  return fetchAPI(stleaf(st, 'zai3pi'), url, {
    method: 'DELETE',
    credentials: 'include',
    headers,
  });
};
